const VideoTourIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M2.91699 12.0837V3.75033C2.91699 3.52931 3.00479 3.31735 3.16107 3.16107C3.31735 3.00479 3.52931 2.91699 3.75033 2.91699H17.0837C17.3047 2.91699 17.5166 3.00479 17.6729 3.16107C17.8292 3.31735 17.917 3.52931 17.917 3.75033V12.0837"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M19.5833 15.417V16.2503C19.5833 16.6924 19.4077 17.1163 19.0952 17.4288C18.7826 17.7414 18.3587 17.917 17.9167 17.917H2.91667C2.47464 17.917 2.05072 17.7414 1.73816 17.4288C1.42559 17.1163 1.25 16.6924 1.25 16.2503V15.417H19.5833Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M10.4163 6.25L7.08301 8.75V12.0833H13.7497V8.75L10.4163 6.25Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
      <path d="M10.417 12.0837V10.417" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};

export default VideoTourIcon;
